/**
 * This file is used to define common queries that types are automatically generated for using the codegen script.
 */

import { gql } from "../../__generated__";

export const GET_MY_PORTFOLIO_WITH_MEDIA = gql(`
  query MyPortfolioWithMedia {
    myPortfolio {
      firstName
      lastName
      phone
      email
			handle
      isEmailHidden
      workHistory {
        id
        name
        description
        budget
        proDoesNotWishToDiscloseBudget
        startedAt
        endedAt
        images {
          id
          name
          mimeType
          originalUrl
          thumbnailUrl
          deletedAt
        }
        clientReview {
          rating
          feedback
        }
        verified
        isPinned
        createdAt
      }
      employmentHistory {
        id
        isPinned
        companyName
        jobTitle
        description
        startedAt
        endedAt
        images {
          id
          name
          mimeType
          originalUrl
          thumbnailUrl
          deletedAt
        }
        monthlySalary
        proDoesNotWishToDiscloseMonthlySalary
        createdAt
      }
      backgroundCheckStatus
      identityVerificationStatus
      certifications {
        id
        name
        issuedBy
        issuedAt
        issuerCertificationId
        url
        verified
        createdAt
      }
			educationEntries {
				id
				schoolName
				fieldOfStudy
				qualification
				verified
				createdAt
      }
      title
      location
      totalBudget
      averageRating
      averageLaborHackJobsRatings {
        averageAppearanceRating
        averagePunctualityRating
        averagePostServiceCleanUpRating
        averageBehaviorRating
        averageProperToolUsageRating
      }
      ratingCount
      overview
      experience
      hasCompletedRequiredPortfolioSteps
    }
  }
`);

export const PRO_EXISTS = gql(`
  query ProExists($phoneNumber: String!) {
    proExists(phoneNumber: $phoneNumber)
  }
`);

export const JOB_TAGS = gql(`
  query JobAdTags {
    jobAdTags {
      id
      name
      group
    }
  }
`);
